<template>
    <div>
        <normal-card class="mt-5">
            <div class="league-match">
                <div class="league-info">
                    <div class="length">
                        <img src="/img/zqx.a285c935.png" />
                        <div class="league-detail">
                            <p>张三</p>
                        </div>
                    </div>
                    <div class="league-btn">
                        <el-button class="addMatchBtn" @click="chooseMatchBtn"
                            style="background-image: linear-gradient(270deg, #00d6ea 0%, #0e6ae9 100%);">合肥市</el-button>
                        <el-button class="addMatchBtn" @click="addMatch"
                            style="background-image: linear-gradient(270deg, #00d6ea 0%, #0e6ae9 100%);width: 150px;">总收益：¥246,223,00</el-button>
                    </div>
                </div>
                <div class="table-area">
                    <div class="changeMatch">
                        <el-image
                            src="/img/zqx.a285c935.png"
                            style="width: 25px;height: 25px;margin-right: 10px;"></el-image>
                        <span>城市：合肥市</span>
                    </div>
                    <div class="addMatch">
                        <el-image
                            src="/img/zqx.a285c935.png"
                            style="width: 25px;height: 25px;margin-right: 10px;"></el-image>
                        <span>商户总数：107/家</span>
                    </div>
                    <div class="signTeam">
                        <el-image
                            src="/img/zqx.a285c935.png"
                            style="width: 25px;height: 25px;margin-right: 10px;"></el-image>
                        <span>用户总数：37,621/人</span>
                    </div>
                    <div class="signPeople">
                        <el-image
                            src="/img/zqx.a285c935.png"
                            style="width: 25px;height: 25px;margin-right: 10px;"></el-image>
                        <span> 交易总额：¥ 867,352.50</span>
                    </div>
                </div>
            </div>
        </normal-card>
    </div>
</template>

<script>
import normalCard from '@/common/components/normal/NormalCard';
export default {
    components: { normalCard },
    data() {
        return {
            matchFormatInfo: {},
            matchTimeInfo: {},
            matchInfo: {},
            matchList: [],
            title: '',
            currentStep: 1,
            propertyOptionList: [],
            pageInfo: {
                page: 1,
                pageSize: 10,
                count: 0,
            },
        };
    },
    mounted() {

    },
    methods: {

    },
};
</script>

<style lang="scss" scoped>
.btn-com {
    display: flex;
    justify-content: center;
    margin-top: 30px;

    .save-btn {
        color: #fff;
        background: rgb(51, 64, 84);
        width: 120px;
    }
}

.league-match {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #ececec;

    .table-area {
        display: flex;
        justify-content: center;
        border-radius: 0 0 10px 10px;
        width: 100%;
        height: 40px;
        font-size: 18px;
        // background-color: #fff;
        border-top: 1px solid #dbdbdb;

        .addMatch,
        .changeMatch,
        .signTeam,
        .signPeople {
            display: flex;
            align-items: center;
            justify-content: center;
            border-right: 1px solid #dbdbdb;
            // background-color: #e0cd78;
            width: 25%;
        }


        .addMatch {
            // background-color: #78e086;
        }

        .signTeam {
            // background-color: #78b1e0;
        }

        .signPeople {
            border-right: none;
            // background-color: #e078c9;
        }
    }

    .league-info {
        width: 100%;
        height: 100px;
        border-radius: 10px 10px 0 0;
        display: flex;
        align-items: center;
        // background: linear-gradient(rgb(51, 64, 84), #3e8597);
        display: flex;
        align-items: center;
        justify-content: space-between;

        .length {
            display: flex;
            align-items: center;
        }

        img {
            width: 65px;
            height: 65px;
            margin-left: 200px;
            margin-right: 20px;
            border-radius: 50%;
        }

        .league-btn {
            display: flex;
            margin-right: 150px;

            .changeMatch {
                width: 100px;
                height: 30px;
                margin-right: 20px;
                border-radius: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                background-image: linear-gradient(270deg, #00d6ea 0%, #0e6ae9 100%);
            }
        }

        .league-detail {
            margin-left: 30px;

            p {
                font-size: 24px;
            }

            .detail {
                margin-top: 10px;

                span:nth-of-type(1) {
                    color: #2e10db;
                }

                span:nth-of-type(2) {
                    color: #e0cd78;
                    margin-left: 20px;
                }
            }
        }

        .addMatchBtn {
            width: 100px;
            height: 30px;
            color: #fff;
            background-image: linear-gradient(270deg, #00d6ea 0%, #0e6ae9 100%);
            border: none;
        }
    }
}
</style>
